import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
      redirectTo: 'home',
      pathMatch: 'full'
  },
  
  {
      path: 'home',
      loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
  },

  {
      path: 'portada',
      loadChildren: () => import('./portada/portada.module').then( m => m.PortadaPageModule),
  },
  
  /****************************************  CONTROL HABITACIONES   ************************************************ */
  {
    path: 'control-habitciones',
    loadChildren: () => import('./control-habitaciones/control-habitaciones.module').then( m => m.ControlHabitacionesPageModule)
  },
  {
    path: 'control-habitciones2',
    loadChildren: () => import('./control-habitaciones2/control-habitaciones2.module').then( m => m.ControlHabitaciones2PageModule)
  },
	/****************************************  CAHT   ************************************************ */
	{
		path: 'chat',
		loadChildren: () => import('./chat/chat.module').then( m => m.ChatPageModule)
	},
  {
		path: 'chat-room',
		loadChildren: () => import('./chat-room/chat-room.module').then( m => m.ChatRoomPageModule)
	},
  {
		path: 'historiconotificaciones',
		loadChildren: () => import('./historiconotificaciones/historiconotificaciones.module').then( m => m.HistoriconotificacionesPageModule)
	},
  {
		path: 'historicowhatsapp',
		loadChildren: () => import('./historicowhatsapp/historicowhatsapp.module').then( m => m.HistoricowhatsappPageModule)
	},
  {
		path: 'comunicaciones',
		loadChildren: () => import('./comunicaciones/comunicaciones.module').then( m => m.ComunicacionesPageModule)
	},
  {
    path: 'list-scenes-light',
    loadChildren: () => import('./resume-stay/scenes/list-scenes-light/list-scenes-light.module').then( m => m.ListScenesLightPageModule)
 },
  /****************************************  DOMO   ************************************************ */
  {
    path: 'reservas',
    loadChildren: () => import('./home/reservas/reservas.module').then( m => m.ReservasPageModule)
 },
 {
  path: 'habitacionesDisponibles',
  loadChildren: () => import('./home/habitacionesDisponibles/habitacionesDisponibles.module').then( m => m.HabitacionesDisponiblesPageModule)
},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
